import React, { useEffect, useRef } from 'react';
import isTouchSupported from '../../../../../helpers/isTouchSupported';
import { INPUT_ELEMENT_ID } from '../components/input/input';

function useClickOutside(open: boolean, setOpen: React.Dispatch<React.SetStateAction<boolean>>): void {
  // used to add events directly to browser rather that through react event delegation
  const documentRef = useRef(document);
  const inputElement = document.getElementById(INPUT_ELEMENT_ID);

  const handleClickOutside = (e: Event) => {
    const insideSearchComponents = (e.target as Element).closest('*[data-click-inside-search]');
    if (!insideSearchComponents) {
      setOpen(false);
      inputElement?.blur();
    }
  };

  const handleTouchOutside = (e: TouchEvent) => {
    if (e.touches.length !== 1) {
      return;
    }

    const insideSearchComponents = (e.target as Element).closest('*[data-click-inside-search]');
    if (insideSearchComponents) {
      return;
    }
    const insideHeader = (e.target as Element).closest('header');
    if (insideHeader) {
      setOpen(false);
      inputElement?.blur();
      return;
    }
    e.preventDefault();
    setOpen(false);
    inputElement?.blur();
  };

  useEffect(() => {
    if (open) {
      documentRef.current.addEventListener('click', handleClickOutside);
      if (isTouchSupported()) {
        documentRef.current.addEventListener('touchstart', handleTouchOutside, { capture: true, passive: false });
      }
    }
    return () => {
      documentRef.current.removeEventListener('click', handleClickOutside);
      if (isTouchSupported()) {
        documentRef.current.removeEventListener('touchstart', handleTouchOutside, { capture: true });
      }
    };
  }, [open]);
}

export default useClickOutside;
